<!-- 宠物 -->
<template>
  <div class="container">
    <login-navigator></login-navigator>
    <publish-nav></publish-nav>
    <publish-status :navStatus="navStatus"></publish-status>
    <section class="main">
      <div class="main-content">
        <form action=""> 
          <div class="basic">
            <h3>基础信息</h3>
          <p><span class="title"><span class="neccessary">*</span>选择身份</span>
              <span class="person radio_label"><el-radio label="1">个人转让</el-radio></span>
              <span class="seller"><el-radio label="2">商家转让</el-radio></span>
          </p>
          <p><span class="title">品种</span><input class="category" type="text" name="category"></p>
          <p><span class="title">价格</span><input class="price" type="text" name="price"></p>
          <p><span class="title">年龄</span><input class="age" type="text" name="age"></p>
          <p><span class="title">毛色</span><input class="color" type="text" name="color"></p>
          <p><span class="title"><span class="neccessary">*</span>驱虫情况</span>
              <span class="clean radio_label"><el-radio label="1">已驱虫</el-radio></span>
              <span class="noClean"><el-radio label="2">未驱虫</el-radio></span>
          </p>
          <p><span class="title">疫苗情况</span><input class="vaccine" type="text" name="vaccine"></p>
          <p><span class="title"><span class="neccessary">*</span>QQ视频看狗</span>
              <span class="support radio_label"><el-radio label="1">支持</el-radio></span>
              <span class="noSupport"><el-radio label="2">未支持</el-radio></span>
          </p>
          <p><span class="title">标题</span><input class="tit" type="text" name="tit"></p>
          </div>
          <div class="extra">
            <h3>其他信息</h3>
            <p><span class="title"><span class="neccessary">*</span>联系人</span><input type="text" name="connector" class="connector"></p>
            <p><span class="title">QQ</span><input class="qq" type="text" name="QQ"></p>
            <p><span class="title"><span class="neccessary">*</span>联系电话</span><input type="text" class="phone" name="phone"></p>
          </div>
          <p class="care-wrap"><span class="title"></span><input class="care" type="checkbox">公布真实号码，电话隐私不受保护</p>
          <p><span class="title"></span><button type="button" @click="publish" class="publish">发布</button></p>
        </form>
      </div>
    </section>
    <modal :showModal="showModal"></modal>
  </div>
</template>

<script>
import LoginNavigator from "../../../components/LoginNavigator";
import PublishNav from "../../../components/PublishNav";
import PublishStatus from "../../../components/PublishStatus";
import Modal from "../../../components/Modal";
export default {
  data() {
    return {
      navStatus: 1,
      showModal: false
    };
  },

  components: {
    LoginNavigator,
    PublishNav,
    PublishStatus,
    Modal
  },
  methods: {
    publish: function() {
      console.log("发布");
      this.showModal = true;
      console.log(this.showModal);
    }
  }
};
</script>
<style scoped>
select {
  font-size: 16px;
}
.main .main-content .radio_label {
  margin-right: 29px;
}
.container {
  background: #f5f5f5;
}
.main {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
}
.main .main-content {
  padding: 47px 0 0 301px;
}
.main .main-content p {
  margin: 39px 0;
}
.main .main-content .title .neccessary {
  color: red;
}
.main .main-content .title {
  display: inline-block;
  width: 100px;
  height: 20px;
  line-height: 20px;
  text-align: right;
  font-size: 16px;
  color: #808080;
  margin-right: 30px;
}
.main .main-content .category,
.price,
.age,
.color,
.vaccine,
.tit,
.connector,
.qq,
.phone {
  height: 40px;
}
.main .main-content .category,
.price,
.age,
.color,
.vaccine,
.connector,
.qq,
.phone {
  width: 280px;
}
.main .main-content .tit {
  width: 420px;
}
.main .main-content input {
  font-size: 16px;
  color: #b3b3b3;
}
.main .main-content .introduce-wrap {
  display: flex;
  align-items: center;
}
.main .main-content .care {
  width: 16px;
  height: 16px;
}
.main .main-content .publish {
  display: inline-block;
  text-align: center;
  width: 260px;
  height: 48px;
  line-height: 48px;
  color: #fff;
  background: #00a0e9;
  border: none;
  font-size: 16px;
}
.main .main-content .care-wrap {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/publishItem/Pet.vue